import React from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header/Header";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import TourPackages from "./components/TourPackages/TourPackages";
import Punjab from "./components/TourPackages/Punjab";
import Sindh from "./components/TourPackages/Sindh";
import Balochistan from "./components/TourPackages/Balochistan.jsx";
import KPK from "./components/TourPackages/KPK";
import GilgitBaltistan from "./components/TourPackages/GilgitBaltistan";
import AzadKashmir from "./components/TourPackages/AzadKashmir";
import Confirmation from "./components/Confirmation/Confirmation";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.min.js";
import PackageDetail from "./components/TourPackages/PackageDetail";
import Error from "./components/Confirmation/error"
import Dashboard from "./components/Dashboard/dashboard";
import User from "./components/Dashboard/user";
import Newuser from "./components/Dashboard/newuser";
import Useredit from "./components/Dashboard/useredit";
import Addpackage from "./components/Dashboard/addpackage";
import Packageactive from "./components/Dashboard/packageactive";
import Testimonial from "./components/Testimonial/Testimonial";
import PrivacyPolicy from "./components/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "./components/TermsConditions/TermsConditions";
import Protected from "./components/Protected";
import Adminregister from  "./components/Header/logins/adminregister";
import Adminlogin from  "./components/Header/logins/adminlogin";



export default function App() {
  return (
    <>
      <div>
        <Router>
          <Routes>
            <Route path="/" element={<Header />} />
            <Route index element={<Home />} />
            <Route path="/Contact" element={<Contact />} />
            <Route path="/Adminregister" element={<Adminregister />} />
            <Route path="/Adminlogin" element={<Adminlogin />} />
            <Route path="/error" element={<Error />} />
            <Route path="/About" element={<About />} />
            <Route path="/TourPackages" element={<TourPackages />} />
            <Route path="/Confirmation" element={<Protected Component={Confirmation}/>} />
            <Route path="/package/:id" element={<Protected Component={PackageDetail}/>} />
            <Route path="/error" element={<Protected Component={Error}/>} />
            <Route path="/Punjab" element={<Punjab />} />
            <Route path="/Sindh" element={<Sindh />} />
            <Route path="/Balochistan" element={<Balochistan />} />
            <Route path="/KPK" element={<KPK />} />
            <Route path="/GilgitBaltistan" element={<GilgitBaltistan />} />
            <Route path="/AzadKashmir" element={<AzadKashmir />} />
            <Route path="/Testimonial" element={<Testimonial />} />
            <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
            <Route path="/TermsConditions" element={<TermsConditions />} />
    
            <Route path="Dashboard" >
            <Route index element={<Protected Component={Dashboard}/>} />
            <Route path="users">
              <Route index element={<Protected Component={User}/>} />
              <Route path="new" element={<Protected  Component={Newuser}/>} />
              <Route path="edit" element={<Protected Component={Useredit} />} />
            </Route>
            <Route path="package">
              <Route index element={<Protected Component={Addpackage} />} />
              <Route path="active" element={<Protected  Component={Packageactive} />} />
            </Route>
            </Route>

          </Routes>
        </Router>
      </div>
    </>
  );
}
